import { buildFormatLongFn } from "../../_lib/buildFormatLongFn.js";
var dateFormats = {
  full: "EEEE, d MMMM yyyy",
  "long": "d MMMM yyyy",
  medium: "d MMM yyyy",
  "short": "dd/MM/yyyy"
};
var timeFormats = {
  full: "HH:mm:ss zzzz",
  "long": "HH:mm:ss z",
  medium: "HH:mm:ss",
  "short": "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  "long": "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  "short": "{{date}}, {{time}}"
};
export var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};